module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai582-d0cb4b847a8eb58723f4036188c5e0aa.jpg";